import React, { useState } from "react";
import { Link, WithHostUrl } from "@quintype/components";
import { get } from "lodash";
import styles from "./styles.m.css";
import { humanizeDateHM } from "../../utils/time-format";
import Media from "react-media";
import { PGAdwithAd } from "../../rows/ad-free";
import SpecialBundleCard from "../../atoms/special-bundle-card";
import LatestNewsStories from "../../atoms/latest-news-stories";
import { HeroImageTextStory } from "../story/story-templates/shared/hero-image";

const LiveUpdatePage = props => {
  const stories = get(props, ["data", "stories"], []);
  const CurrentDate = get(props, ["data", "date"], []);

  const firstStoryImageKey = get(stories, [0]);

  const [visibleCount, setVisibleCount] = useState(20); // Show 20 initially

  const handleLoadMore = () => {
    setVisibleCount(prev => Math.min(prev + 20, stories.length));
  };

  const visibleStories = stories.slice(0, visibleCount);

  const heroimageWithShare = (
    <React.Fragment>
      <HeroImageTextStory story={firstStoryImageKey} />
    </React.Fragment>
  );

  // Get current date in YYYY-MM-DD format
  const getCurrentDate = () => {
    const today = new Date();
    return today.toISOString().split("T")[0];
  };

  return (
    <div className="container">
      <div className={styles["main-story-grid"]}>
        <div className={styles["left-side-panel"]}>
          <div className={styles["top-section"]}>
            <ul className={styles["breadcrumbs"]} itemScope itemType="http://schema.org/BreadcrumbList">
              <li
                className={styles["breadcrumb"]}
                itemProp="itemListElement"
                itemScope
                itemType="http://schema.org/ListItem"
              >
                <WithHostUrl>
                  {({ primaryHostUrl }) => (
                    <Link aria-label="Vikatan" href={primaryHostUrl && primaryHostUrl} itemprop="item">
                      <span itemProp="name">Home</span>
                    </Link>
                  )}
                </WithHostUrl>
                <meta itemProp="position" content={1} />
              </li>
              <li
                className={styles["breadcrumb"]}
                itemProp="itemListElement"
                itemScope
                itemType="http://schema.org/ListItem"
              >
                <Link aria-label={`${"Navigate to "}`} href={"#"} itemprop="item">
                  <span itemProp="name">{"Live Updates"}</span>
                </Link>
                <meta itemProp="position" content={2} />
              </li>
            </ul>
            {CurrentDate === getCurrentDate() && (
              <div>
                <span className={styles["liveblink"]}>
                  <span className={styles["livenow"]}>LIVE</span>
                </span>
              </div>
            )}
          </div>
          <h1 className={styles["headline"]}>{`நேரலை செய்திகள்: இன்று வெளியான News Articles - ${CurrentDate}`}</h1>
          <div className={styles["hero-image-wrapper"]}>{heroimageWithShare}</div>
          {visibleStories.length === 0 ? (
            <div className={styles["page-404"]}>
              <h2>No updates available.</h2>
            </div>
          ) : (
            <div className={styles["live-blog-wrapper"]}>
              <div className={styles["live-blog"]}>
                {visibleStories.map((story, index) => (
                  <React.Fragment key={story.id || index}>
                    <div className={styles["live-entry"]}>
                      <div className={styles["date"]}>
                        <timestamp className={styles["timestamp"]}>{humanizeDateHM(story["published-at"])}</timestamp>
                      </div>
                      <Link href={story.url || `/${story.slug || ""}`}>
                        <a className={styles["headline-link"]}>
                          <h3 className={styles["story-headline"]}>{story.headline}</h3>
                          <p className={styles["subheadline"]}>{story.subheadline}</p>
                        </a>
                      </Link>
                    </div>

                    <div className={styles["livestory-ad"]}>
                      {/* Inject ad after every 5th story */}
                      {(index + 1) % 5 === 0 && (
                        <Media query="(min-width:768px)">
                          <PGAdwithAd
                            adId={`Vikatan2023_Desktop_AP_RightMID_336x280`}
                            adSize={[[336, 280], [300, 250]]}
                            minHeight={280}
                            adDivId={`div-ad-desk-3849069-1690281136-1_${index}`}
                            class="ad_300_250"
                            story={"goldpage"}
                          />
                        </Media>
                      )}
                    </div>
                  </React.Fragment>
                ))}

                {visibleCount < stories.length && (
                  <div style={{ textAlign: "center", marginTop: "20px" }}>
                    <button onClick={handleLoadMore} className={styles["load-more-button"]}>
                      Load More
                    </button>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
        <div className={styles["right-side-panel"]}>
          <aside className={`${styles["right-sidebar"]} ${styles.sidebar}`}>
            <Media query="(min-width:768px)">
              <PGAdwithAd
                adId={`Vikatan2023_Desktop_AP_RightATF_336x280`}
                adSize={[[336, 280], [300, 250]]}
                minHeight={280}
                adDivId={`div-ad-desk-3849069-1690281136-2_${"52d3fe06-4ff8-4e9e-84e1-59c040c0490a"}`}
                class="ad_300_250"
                story={"goldpage"}
                // config={this.props.config}
              />
            </Media>
            <LatestNewsStories collectionSlug="latest-news-collection" title="லேட்டஸ்ட் செய்திகள்" />
            <Media query="(min-width:768px)">
              <PGAdwithAd
                adId={`Vikatan2023_Desktop_AP_RightMID_336x280`}
                adSize={[[336, 280], [300, 250]]}
                minHeight={280}
                adDivId={`div-ad-desk-3849069-1690281136-1_${123}`}
                class="ad_300_250"
                story={"goldpage"}
                // config={this.props.config}
              />
            </Media>
            <Media query="(min-width:768px)">
              <SpecialBundleCard className="feed-page" config={""} />
            </Media>
            <Media query="(min-width:768px)">
              <div className={`${styles["ad-halfpage"]} hidden-mobile`}>
                <PGAdwithAd
                  adId={`Vikatan2023_Desktop_AP_RHS_300x600`}
                  adSize={[[300, 600]]}
                  minHeight={600}
                  adDivId={`div-ad-desk-3849069-1690281136-0_${1234}`}
                  class="ad-300x600"
                  story={"story"}
                  config={""}
                />
              </div>
            </Media>
          </aside>
        </div>
      </div>
    </div>
  );
};

export { LiveUpdatePage };
